var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1100px",
        title: "风控信息",
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: { close: _setup.handleClose },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "danger",
                    loading: _setup.auditing,
                    disabled: _setup.auditing,
                  },
                  on: {
                    click: function ($event) {
                      return _setup.handleAudit(0)
                    },
                  },
                },
                [_vm._v("不通过")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _setup.auditing,
                    disabled: _setup.auditing,
                  },
                  on: {
                    click: function ($event) {
                      return _setup.handleAudit(1)
                    },
                  },
                },
                [_vm._v("通过")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.loading,
              expression: "loading",
            },
          ],
          staticClass: "dialog-content",
        },
        [
          _c("div", { staticClass: "section-title" }, [_vm._v("提现订单数据")]),
          _c(
            "el-descriptions",
            {
              staticClass: "desc",
              attrs: {
                column: 3,
                border: "",
                size: "small",
                contentStyle: { width: "22%", padding: "4px 10px" },
                labelStyle: { width: "200px" },
              },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                _vm._v(_vm._s(_setup.dataView.order_id || "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "订单状态" } }, [
                _vm._v(_vm._s(_setup.statusText)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "提款金额" } }, [
                _vm._v(_vm._s(_setup.formatMoney(_setup.dataView.amount))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "预计到账" } }, [
                _vm._v(
                  _vm._s(_setup.formatMoney(_setup.dataView.estimated_amount))
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "实际到账" } }, [
                _vm._v(_vm._s(_setup.formatMoney(_setup.dataView.real_amount))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "总手续费" } }, [
                _vm._v(_vm._s(_setup.formatMoney(_setup.dataView.total_fee))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "代付通道" } }, [
                _vm._v(_vm._s(_setup.dataView.payment_channel_name || "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "提款账号" } }, [
                _vm._v(_vm._s(_setup.dataView.account || "--")),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section-title",
              staticStyle: { "margin-top": "12px" },
            },
            [_vm._v("会员汇总数据")]
          ),
          _c(
            "el-descriptions",
            {
              staticClass: "desc",
              attrs: {
                column: 3,
                border: "",
                size: "small",
                contentStyle: { width: "22%", padding: "4px 10px" },
                labelStyle: { width: "200px" },
              },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "会员ID" } }, [
                _vm._v(_vm._s(_setup.dataView.uid ?? "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "会员账号" } }, [
                _vm._v(_vm._s(_setup.dataView.username || "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "VIP等级" } }, [
                _setup.dataView.vip_level != null
                  ? _c("span", [
                      _vm._v("VIP" + _vm._s(_setup.dataView.vip_level)),
                    ])
                  : _c("span", [_vm._v("--")]),
              ]),
              _c("el-descriptions-item", { attrs: { label: "账户余额" } }, [
                _vm._v(_vm._s(_setup.formatMoney(_setup.dataView.gold))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "上级代理" } }, [
                _vm._v(_vm._s(_setup.dataView.inviter_uid ?? "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "注册来源" } }, [
                _vm._v(_vm._s(_setup.registerTypeText)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "会员标签" } }, [
                _vm._v(_vm._s(_setup.dataView.vip_tags || "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "同IP人数" } }, [
                _vm._v(_vm._s(_setup.dataView.same_ip_num ?? "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "累计充值" } }, [
                _vm._v(
                  _vm._s(
                    _setup.formatMoney(_setup.dataView.total_payin_amount)
                  ) +
                    "（" +
                    _vm._s(_setup.dataView.total_payin_times ?? 0) +
                    "次）"
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "累计提款" } }, [
                _vm._v(
                  _vm._s(
                    _setup.formatMoney(_setup.dataView.total_payout_amount)
                  ) +
                    "（" +
                    _vm._s(_setup.dataView.total_payout_times ?? 0) +
                    "次）"
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "今日充值" } }, [
                _vm._v(
                  _vm._s(
                    _setup.formatMoney(_setup.dataView.today_payin_amount)
                  ) +
                    "（" +
                    _vm._s(_setup.dataView.today_payin_times ?? 0) +
                    "次）"
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "今日提款" } }, [
                _vm._v(
                  _vm._s(
                    _setup.formatMoney(_setup.dataView.today_payout_amount)
                  ) +
                    "（" +
                    _vm._s(_setup.dataView.today_payout_times ?? 0) +
                    "次）"
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "活动奖励" } }, [
                _vm._v(
                  _vm._s(_setup.formatMoney(_setup.dataView.reward_amount))
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "累计盈亏/损益" } },
                [_vm._v(_vm._s(_setup.formatMoney(_setup.dataView.total_earn)))]
              ),
              _c("el-descriptions-item", { attrs: { label: "上次充值时间" } }, [
                _vm._v(_vm._s(_setup.formatTs(_setup.dataView.last_payin_at))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "上次提款时间" } }, [
                _vm._v(_vm._s(_setup.formatTs(_setup.dataView.last_payout_at))),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section-title",
              staticStyle: { "margin-top": "12px" },
            },
            [_vm._v("统计周期数据")]
          ),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(_setup.SchemaTablePage, {
                ref: "tablePageRef",
                attrs: {
                  "layout-mode": "dialog",
                  "search-schema": [],
                  columns: _setup.columns,
                  "default-query": {},
                  request: _setup.request,
                  "build-params": _setup.buildParams,
                  "parse-result": _setup.parseResult,
                  "table-attrs": { size: "mini" },
                  immediate: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "colLogType",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_setup.logTypeText(row.log_type)))]
                    },
                  },
                  {
                    key: "colPayin",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_setup.formatMoney(row.payin_amount))),
                      ]
                    },
                  },
                  {
                    key: "colPayout",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_setup.formatMoney(row.payout_amount))),
                      ]
                    },
                  },
                  {
                    key: "colBet",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_setup.formatMoney(row.bet_amount))),
                      ]
                    },
                  },
                  {
                    key: "colWinloss",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_setup.formatMoney(row.winloss)))]
                    },
                  },
                  {
                    key: "colEarn",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_setup.formatMoney(row.earn)))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }